import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import i18n from 'i18next';
import { processRequest } from '../../../services/Api';
import { answerModalActionTypes } from './Constants';
import { uploadFileHelper } from '../../../pagesNext/shared/Sagas';
import { getZendeskUrl } from '../../../services/Helper';
import * as answerModalActions from './Actions';
import * as notificationActions from '../../notification/Actions';
import * as qaActions from '../../../pagesNext/qA/Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';
import { userId } from './Selectors';

export default function* () {
	yield all([
		takeLatest(
			answerModalActionTypes.UPLOAD_ANSWER_ATTACHMENT_REQUEST,
			handleUploadImageRequest,
		),
		takeLatest(answerModalActionTypes.CREATE_ANSWER_REQUEST, createAnswerRequest),
		takeLatest(answerModalActionTypes.UPDATE_ANSWER_REQUEST, updateAnswerRequest),
	]);
}

function createNotificationAction(notification_status, edit, isOwnQuestion) {
	const isDeletedStatus =
		notification_status === 'deleted_after_creation' ||
		notification_status === 'deleted_after_edit';

	return notificationActions.createNotification(
		i18n.t(
			`modals.answer_modal.notifications.${
				isDeletedStatus
					? notification_status
					: edit
					? 'edited'
					: isOwnQuestion
					? 'own_reply'
					: notification_status
			}`,
		),
		null,
		isDeletedStatus,
		isDeletedStatus ? 180000 : 5000,
		true,
		null,
		isDeletedStatus ? { title: i18n.t('general.rules_btn') } : undefined,
		isDeletedStatus
			? () => window.open(getZendeskUrl('zendesk_removed_question_or_answer_url'), '_blank')
			: undefined,
	);
}

export function* handleUploadImageRequest({ payload }) {
	try {
		const { file, questionId } = payload || {};

		const { linkToFile, fileName } = yield call(
			uploadFileHelper,
			`qna/questions/${questionId}/answers`,
			file,
		);

		yield put(answerModalActions.uploadImageSuccess(linkToFile, fileName));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(answerModalActions.uploadImageError());
	}
}

export function* createAnswerRequest({ payload }) {
	try {
		const { data: formData, questionId, answerUserId } = payload || {};

		const { data } = yield call(
			processRequest,
			`qna/questions/${questionId}/answers`,
			'POST',
			formData,
		);

		const { qna_answer: { notification_status } = {} } = data || {};

		const isOwnQuestion = (yield select(userId)).toString() === answerUserId.toString();

		yield put(answerModalActions.createAnswerSuccess());
		yield put(qaActions.getQuestionDetails({ questionId, reload: true }));
		yield put(createNotificationAction(notification_status, false, isOwnQuestion));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(answerModalActions.createAnswerError());
	}
}

export function* updateAnswerRequest({ payload }) {
	try {
		const { data: formData, questionId, answerId } = payload || {};

		const { data } = yield call(
			processRequest,
			`qna/questions/${questionId}/answers/${answerId}`,
			'PATCH',
			formData,
		);

		const { qna_answer: { notification_status } = {} } = data || {};

		yield put(qaActions.getQuestionDetails({ questionId, reload: true }));
		yield put(answerModalActions.updateAnswerSuccess());
		yield put(createNotificationAction(notification_status, true));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(answerModalActions.createAnswerError());
	}
}
